<div #meetingsContainer class="meetings-container">
  @let showOnlyToBeJoinedMeetings = showOnlyToBeJoinedMeetings$ | async;
  @if (useGroupingByDate && meetingListType === 'upcoming') {
    <div class="all-meetings-toggle-container">
      <mat-slide-toggle
        [ngModel]="showOnlyToBeJoinedMeetings"
        (ngModelChange)="toggleShowOnlyToBeJoinedMeetings($event)"
        labelPosition="before"
        class="filter-toggle"
        [matTooltip]="'MEETINGS.UPCOMING_MEETING.FILTER_TOOLTIP' | translate"
      >
        <span class="filter-label">
          {{ 'MEETINGS.BRIEF_ENABLED' | translate }}
        </span>
      </mat-slide-toggle>
    </div>
  }

  @if (useGroupingByDate) {
    @if (meetingListType === 'upcoming') {
      @if (ongoingMeetings$ | async; as ongoingMeetings) {
        @if (ongoingMeetings.length > 0) {
          <div class="header-with-filter">
            <h2 class="date-group">{{ 'MEETINGS.ONGOING' | translate }}</h2>
          </div>
          <div class="meetings">
            @for (meeting of ongoingMeetings; track meeting.id) {
              <div class="ongoing-meeting">
                <app-ongoing-meeting-card
                  [meeting]="meeting"
                  [isExpanded]="true"
                  [useHighlight]="true"
                  [attr.data-meeting-id]="meeting.id"
                ></app-ongoing-meeting-card>
              </div>
            }
          </div>
        }
      }
    }
    @for (meetingGroup of (filteredGroupedMeetings$ | async) ?? []; track meetingGroup.date; let isFirst = $first) {
      @if (isFirst && meetingListType === 'upcoming') {
        <h2 class="date-group">{{ meetingGroup.date }}</h2>
      } @else {
        <h2 class="date-group">{{ meetingGroup.date }}</h2>
      }
      <div class="meetings">
        @for (meeting of meetingGroup.meetings; track meeting.id) {
          <div waIntersectionObserver waIntersectionThreshold="0.5" (waIntersectionObservee)="onMeetingVisible($event, meeting)">
            @if (meetingListType === 'past') {
              <app-previous-meeting-card
                [meeting]="meeting"
                [activeMatch]="activeMatch"
                [isActive]="activeMeeting !== null && activeMeeting.id === meeting.id"
                (mouseenter)="hoverMeeting.emit(meeting)"
                [attr.data-meeting-id]="meeting.id"
              ></app-previous-meeting-card>
            } @else if (meetingListType === 'upcoming') {
              <app-upcoming-meeting-card [meeting]="meeting" [attr.data-meeting-id]="meeting.id"></app-upcoming-meeting-card>
            }
          </div>
        }
      </div>
    } @empty {
      @if (meetingListType === 'past') {
        <p class="no-matching-meetings" translate="MEETINGS.NO_MEETINGS_PAST"></p>
      } @else if (meetingListType === 'upcoming') {
        <p class="no-matching-meetings" translate="MEETINGS.NO_MEETINGS_UPCOMING"></p>
      }
    }
  } @else {
    <div class="meetings">
      @for (meeting of meetings; track meeting.id) {
        @if (meetingListType === 'past') {
          <app-previous-meeting-card
            [meeting]="meeting"
            [activeMatch]="activeMatch"
            [isActive]="activeMeeting !== null && activeMeeting.id === meeting.id"
            [useCompactMode]="true"
            (mouseenter)="hoverMeeting.emit(meeting)"
            [attr.data-meeting-id]="meeting.id"
          ></app-previous-meeting-card>
        } @else if (meetingListType === 'upcoming') {
          <app-upcoming-meeting-card [meeting]="meeting" [attr.data-meeting-id]="meeting.id"></app-upcoming-meeting-card>
        }
      }
    </div>
  }
  @if (hasMore) {
    <div class="load-more-container" waIntersectionObserver waIntersectionThreshold="0.5" (waIntersectionObservee)="loadMore()">
      @if (isFetchingNextPage) {
        <app-spinner></app-spinner>
      }
    </div>
  }
</div>
